import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../../Translations';
import OnDemandIcon from '../../../ExperienceCatalog/Experience/OnDemand/OnDemandIcon';

const OnDemand: React.FC = () => (
  <div className="flex items-center text-sm">
    <div className="mr-2">
      <OnDemandIcon />
    </div>
    <div className="font-xs">
      <T kind="On Demand" />
    </div>
  </div>
);

export default observer(OnDemand);
